import { render, staticRenderFns } from "./Tableu.vue?vue&type=template&id=0527695e&scoped=true&lang=true&"
import script from "./Tableu.vue?vue&type=script&lang=js&"
export * from "./Tableu.vue?vue&type=script&lang=js&"
import style0 from "./Tableu.vue?vue&type=style&index=0&id=0527695e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0527695e",
  null
  
)

export default component.exports